import { inject, Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { UserEntity } from '@zerops/zerops/core/user-base';
import { FreeResourceSummaryEntity } from './free-resource-summary-base.entity';
import {
  onWebsocketMessageDispatchAddRemoveEntities,
  onWebsocketMessageDispatchUpdateEntities
} from '@zerops/zef/entities';

@Injectable()
export class FreeResourceSummaryBaseEffect {

  #actions = inject(Actions);
  #userEntity = inject(UserEntity);
  #freeResourceEntity = inject(FreeResourceSummaryEntity)

  setupResourceSummaryListStream$ = createEffect(() => this.#userEntity.activeClientId$.pipe(
    map((clientId) => this.#freeResourceEntity.listSubscribe(clientId))
  ));

  onResourceSummaryListChangeStream$ = createEffect(() => this.#actions.pipe(
    onWebsocketMessageDispatchAddRemoveEntities(
      this.#freeResourceEntity
    )
  ));

  setupResourceSummaryUpdateStream$ = createEffect(() => this.#userEntity.activeClientId$.pipe(
    map((clientId) => this.#freeResourceEntity.updateSubscribe(clientId)
  )));

  onResourceSummaryUpdateChangeStream$ = createEffect(() => this.#actions.pipe(
    onWebsocketMessageDispatchUpdateEntities(this.#freeResourceEntity)
  ));

}
